/**
 * @generated SignedSource<<119d548cc08a067637afcea3036fa6d5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type defaultArticleDateContent$data = {
  readonly createdDate: number | null | undefined;
  readonly publishedDate: number | null | undefined;
  readonly updatedDate: number | null | undefined;
  readonly " $fragmentType": "defaultArticleDateContent";
};
export type defaultArticleDateContent$key = {
  readonly " $data"?: defaultArticleDateContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"defaultArticleDateContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "defaultArticleDateContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedDate",
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "b70e6c710c35cc3d3c15bdce66a3980a";

export default node;
